import { render, staticRenderFns } from "./HeartbeatFlags.vue?vue&type=template&id=0ea51729&"
import script from "./HeartbeatFlags.vue?vue&type=script&lang=js&"
export * from "./HeartbeatFlags.vue?vue&type=script&lang=js&"
import style0 from "./HeartbeatFlags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports